export const shouldCapture = ({ sampleRate }: { sampleRate?: number }): boolean => {
    if (sampleRate === undefined) return true;

    return Math.random() < sampleRate;
};
